import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 161511 $
// Purpose     : single record properties lists
// =============================================================================
// ---Third-party imports
import React from 'react';
import { List, Table } from 'semantic-ui-react';
// ---Framework imports
import { isString, strip } from 'ldash';
import log from 'uix/logging';
import { Sel, Actions } from 'uix/registries';
import { useSelector, useState, useEffect, usePhysicalNode } from 'uix/hooks';
// ---Local imports
import { useColumnsForNode } from './hooks';
import { getPropSet } from './propcfg';
import { getColumLabel } from './columnTypes';
import S from './styles.css';
// ---Globals
// ---Exports
export const PropertyTable = ({ columnList, namespaceLabels = false, buildLabel = null, raw = false })=>{
    let i18n = useSelector(Sel.i18n);
    let rows = columnList.map((col)=>{
        let { colns, i18nKey, rendered, value } = col;
        let label = buildLabel ? buildLabel(i18nKey) : i18n.span(i18nKey);
        if (namespaceLabels && colns) {
            let ns = i18n.span(`colns_${colns}`);
            label = /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    ns,
                    ": ",
                    label
                ]
            });
        }
        return /*#__PURE__*/ _jsxs(Table.Row, {
            children: [
                /*#__PURE__*/ _jsx(Table.Cell, {
                    className: S.cellLabel,
                    children: label
                }),
                /*#__PURE__*/ _jsx(Table.Cell, {
                    className: S.cellContent,
                    children: rendered
                }),
                raw && /*#__PURE__*/ _jsx(Table.Cell, {
                    children: `${col.id}: ${value}`
                })
            ]
        }, col.id);
    });
    return /*#__PURE__*/ _jsx(Table, {
        definition: true,
        compact: true,
        children: /*#__PURE__*/ _jsx(Table.Body, {
            children: rows
        })
    });
};
export const NodeDefaultProps = ({ node, showEmpty })=>{
    let colids = getPropSet(node.datatypeName, 'default');
    let columnList = useColumnsForNode({
        colids,
        nodeData: node,
        showEmpty
    });
};
const DEFAULT_FIELDS = [
    'otid',
    'type',
    'caption'
];
export const PropertyList = ({ header, subheader, fields = DEFAULT_FIELDS, showEmpty = false, columnLabel })=>{
    if (isString(fields)) {
        fields = fields.split(',').map((e)=>strip(e));
    }
    let i18n = useSelector(Sel.i18n);
    let node = usePhysicalNode();
    let columnList = useColumnsForNode({
        fields,
        nodeData: node,
        showEmpty
    });
    let items = columnList.map((col)=>{
        let { colns, i18nKey, rendered, value } = col;
        let label = getColumLabel(col.id, i18n, i18nKey, columnLabel);
        return /*#__PURE__*/ _jsxs(List.Item, {
            children: [
                /*#__PURE__*/ _jsx(List.Header, {
                    children: label
                }),
                rendered || /*#__PURE__*/ _jsx(_Fragment, {
                    children: " "
                })
            ]
        }, col.id);
    });
    let list_head = null;
    if (header) {
        list_head = /*#__PURE__*/ _jsx(List.Item, {
            children: /*#__PURE__*/ _jsxs(List.Content, {
                children: [
                    /*#__PURE__*/ _jsx(List.Header, {
                        children: header
                    }),
                    subheader
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsxs(List, {
        horizontal: true,
        relaxed: true,
        children: [
            list_head,
            items
        ]
    });
};
